/* eslint no-undef: 0 */
/* eslint no-unused-vars: 0 */
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta';
import router from './router/index';
//import Keycloak from 'keycloak-js';

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(VueRouter);

// const keycloak = new Keycloak({
//     realm: 'dev',//本番は本場用で別に用意。http://localhost:8082
//     //url: 'http://localhost:8082/realms/dev/protocol/openid-connect/auth', // KeycloakサーバーのURL
//     url: 'http://localhost:8080', // KeycloakサーバーのURL
//     clientId: 'simulator',
//     checkLoginIframe: false,
//       secret: 'ecfv6tLKOdRnYKdB5S4OYH5cQfCXjSMT'
// });

// keycloak.init({ onLoad: 'login-required'}).then((auth) => {
//     if (!auth) {
//       window.location.reload();
//     } else {
//       Vue.prototype.$keycloak = keycloak;

//       new Vue({
//         router,
//         render: h => h(App),
//         created() {
//           // URLからクエリパラメータを取得
//           const queryParams = new URLSearchParams(window.location.search);
  
//           // シミュレータルートにリダイレクト
//           if (window.location.pathname === '/simulator') {
//             this.$router.push({
//               path: '/simulator',
//               query: queryParams
//             });
//           }
//         }
//       }).$mount('#app')
//     }
//   })
//   .catch((error) => {
//     console.error('Keycloak init failed:', error);
//   });

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')